<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import { i18n } from './../libs/lang.js';
  import { api } from "./../libs/api.js";

  function handle_start(ev) {
    if (api.is_loggedin())
      navigate("/start");
    else
      navigate("/login");
  }
</script>

<div>
  <div class="hero min-h-screen bg-base-100">
    <div class="hero-content flex flex-col-reverse md:flex-row">

      <div class="w-full md:w-1/2 md:p-16">
        <img src="/assets/Coder.svg" />
      </div>

      <div class="w-full md:w-1/2 md:p-16 mb-6 md:mb-0">
        <img class="w-96 mx-auto" src="/assets/logo.png" />
        <button class="btn btn-accent uppercase block mt-12 w-32 mx-auto" on:click={handle_start}> {$_('base.start')} </button>
      </div>
    </div>
  </div>
</div>

